/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { pageApi } from '@/main/api/page.api';
import { userNotificationsTags } from '@/main/modules/app/apiTags';
import { EHttpMethod } from '@/main/modules/app/appConstants';
import { invalidateOnSuccess } from '@/main/utils/invalidateOnSuccess';

export const ordersApi = pageApi.injectEndpoints({
    endpoints: (builder) => ({
        sendOrdersListViewed: builder.mutation<void, void>({
            query: () => ({
                url: 'orders/list/viewed',
                method: EHttpMethod.PUT,
            }),
            invalidatesTags: (_result, error) =>
                invalidateOnSuccess(error, [userNotificationsTags.USER_NOTIFICATIONS_LIST]),
        }),
    }),
});

export const { useSendOrdersListViewedMutation } = ordersApi;
